import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MoovyThemeProvider, MoovyToastProvider } from 'moovy-ui-core';
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './authContext.js';
import { LocaleProvider } from './localeContext.js';
import { ThemeProvider, useTheme } from './themeContext.js';
const AppProvidersInner = (props) => {
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                gcTime: 5 * 60 * 1000,
                staleTime: 5 * 60 * 1000,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                retry: (failureCount, error) => {
                    var _a, _b;
                    if (((_b = (_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== 'get') {
                        return false;
                    }
                    return failureCount < 3;
                },
                retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
            },
            mutations: {
                retry: 2,
            },
        },
    }));
    const { themeObject } = useTheme();
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(LocaleProvider, { children: _jsx(AuthProvider, { children: _jsx(MoovyThemeProvider, { theme: themeObject, children: _jsx(MoovyToastProvider, { children: props.children }) }) }) }) }));
};
const AppProviders = (props) => {
    return (_jsx(BrowserRouter, { children: _jsx(ThemeProvider, { children: _jsx(AppProvidersInner, { children: props.children }) }) }));
};
export default AppProviders;
